// @file utility functions related to post drafts
import { PostColor } from '@@/types'

export function shouldSyncDraftUpdates<E extends number | string | PostColor | undefined | null>({
  newAttributes,
  oldAttributes,
}: {
  newAttributes: E[]
  oldAttributes: E[]
}): boolean {
  // convert undefined into null for comparison
  const normalizedNewAttributes: Array<NonNullable<E> | null> = newAttributes.map((v) => (v == null ? null : v))
  const normalizedOldAttributes: Array<NonNullable<E> | null> = oldAttributes.map((v) => (v == null ? null : v))

  return normalizedNewAttributes.some((value, index) => normalizedOldAttributes[index] !== value)
}
